import * as React from "react"

import { cn } from "@/shared/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-11 w-full rounded-xl border-2 border-visagio-off-white bg-white px-4 py-2 font-body text-base text-visagio-teal-dark placeholder:text-visagio-gray transition-all duration-200 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground focus:outline-none focus:border-visagio-teal focus:ring-2 focus:ring-visagio-teal/20 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
